import { ImageOff } from 'lucide-react'

import { COMMON } from '@brickup/shared/locales/de/common'
import { cn } from '@/components/base'

/**
 * What stands in the slot of a picture that is not there.
 *
 * One mark for a slot that never had a picture and for one whose picture did
 * not load: the app cannot always tell them apart, and a reader cannot act on
 * the difference. One mark whatever the slot holds, too — the row beside it
 * says what the entry is.
 *
 * It carries the ground, and only it: a picture fills its slot to the edge, and
 * an empty slot needs something there or it is a hole in the layout.
 * `rounded-[inherit]` takes the corner the slot already has, so a caller states
 * its radius once.
 */
export function ImageFallback({
  layout = 'tile',
  className,
}: {
  /** `tile` fills a thumbnail or a cell; `panel` has room to say what is wrong. */
  layout?: 'tile' | 'panel'
  /** The ground, where the slot wants one other than the default. */
  className?: string
}) {
  return (
    <div
      className={cn(
        'flex h-full w-full items-center justify-center rounded-[inherit]',
        'bg-line-soft text-faint',
        layout === 'panel' && 'flex-col gap-2',
        className,
      )}
    >
      {layout === 'panel' ? (
        <>
          <span className="rounded-full bg-border p-5">
            <ImageOff size={32} aria-hidden />
          </span>
          <span className="text-xs text-muted-foreground">
            {COMMON.imageUnavailable}
          </span>
        </>
      ) : (
        <ImageOff size={18} aria-hidden />
      )}
    </div>
  )
}
